export default "__VITE_ASSET__DSmNYqbS__"